import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import routing from "routing";
import useSearchParams from "src/hooks/useSearchParams";
import CourseIcon from "src/images/Icons/newIcons/navigation/courses.svg";
import PickerNewItem from "src/images/Icons/newIcons/newItem.svg";
import SimulationIcon from "src/images/Icons/newIcons/simulation.svg";

import { Header } from "../../../Main/ExamsBox/ExamsBox";
import { DefaultPicker } from "./DefaultPicker";

export function CoursesTypePicker() {
	const { t } = useTranslation();
	const search = useSearchParams();
	const folderParam = search?.folderId ? `?folderId=${search.folderId}` : "";

	return (
		<DefaultPicker
			Header={
				<Header
					title={t("contentPicker.courseType.title")}
					icon={<CourseIcon className={cx("icon-super-big icon-logo")} />}
					withBackButton
				/>
			}
			boxes={[
				{
					title: t("contentPicker.courseType.basic.title"),
					subtitle: t("contentPicker.courseType.basic.subtitle"),
					path: `${routing.paths.createCourse}${folderParam}`,
					submitText: t("contentPicker.courseType.basic.submit"),
					Icon: PickerNewItem,
					testId: "course-type-basic",
				},
				{
					title: t("contentPicker.courseType.templates.title"),
					subtitle: t("contentPicker.courseType.templates.subtitle"),
					path: `${routing.paths.courseTemplates}${folderParam}`,
					submitText: t("contentPicker.courseType.templates.submit"),
					Icon: SimulationIcon,
					variant: "primary",
					isNew: true,
					testId: "course-type-templates",
				},
			]}
		/>
	);
}
